import * as v from "valibot";
import { rpcContract } from "../rpc";

/**
 * Create Stripe checkout session for subscription
 * Starts the subscription payment flow for a creator's Premium Membership
 * Returns session details for redirect to Stripe Checkout
 */
export const createSubscriptionCheckoutRpcContract = rpcContract({
  name: "create-subscription-checkout",
  paramsSchema: v.object({
    influencerId: v.string(),
  }),
  resultSchema: v.object({
    sessionId: v.string(),
    url: v.string(),
  }),
});

export type CreateSubscriptionCheckoutParams = v.InferOutput<
  (typeof createSubscriptionCheckoutRpcContract)["paramsSchema"]
>;
export type CreateSubscriptionCheckoutResult = v.InferOutput<
  (typeof createSubscriptionCheckoutRpcContract)["resultSchema"]
>;
